"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualConfig = void 0;
var source_1 = require("../sources/source");
var baseConfig_1 = require("./baseConfig");
var ContextualConfig = /** @class */ (function (_super) {
    __extends(ContextualConfig, _super);
    function ContextualConfig(_a) {
        var context = _a.context, contextualSource = _a.contextualSource, sources = _a.sources, props = __rest(_a, ["context", "contextualSource", "sources"]);
        var _this = _super.call(this, __assign(__assign({}, props), { source: __spread(sources, [contextualSource]) })) || this;
        _this.context = context;
        _this.contextualSource = contextualSource;
        return _this;
    }
    ContextualConfig.prototype.get = function (key) {
        return _super.prototype.get.call(this, key, this.context);
    };
    ContextualConfig.prototype.getStrict = function (key) {
        return _super.prototype.getStrict.call(this, key, this.context);
    };
    ContextualConfig.prototype.has = function (key) {
        return _super.prototype.has.call(this, key, this.context);
    };
    ContextualConfig.prototype.dumpForContext = function (keys) {
        return _super.prototype.dumpForContext.call(this, keys, this.context);
    };
    ContextualConfig.prototype.injectSettings = function (settings) {
        return this.contextualSource.inject(settings);
    };
    ContextualConfig.prototype.attach = function (context) {
        var contextualSource = new source_1.Source();
        return new ContextualConfig({
            context: context,
            contextualSource: contextualSource,
            sources: this.sources,
            matcher: this.matcher,
            transformer: this.transformer,
        });
    };
    return ContextualConfig;
}(baseConfig_1.BaseConfig));
exports.ContextualConfig = ContextualConfig;
//# sourceMappingURL=contextualConfig.js.map